import * as OnboardingActions from 'actions/OnboardingActions';
import type {EntityStoreUser} from 'constants/EntityStoreConstants';
import {EventConstants} from 'constants/EventConstants';
import * as UserDAO from 'dao/UserDAO';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';
import * as net from 'util/Net';

export function loadOrgs(): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.ORG_FETCH,
  });

  UserDAO.getCurrentOrgs()
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.ORG_FETCH_COMPLETED,
        entityId: EntityStore.currentUser().id,
        orgs: response,
      });
    })
    .fail((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.ORG_FETCH_FAILED,
        error: response,
      });
    });
}

export function loadOrgRequests(): void {
  UserDAO.getOrgRequests()
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_FETCH_ORG_REQUESTS_COMPLETED,
        entityId: EntityStore.currentUser().id,
        userOrgsInboundRequests: response!.userOrgsInboundRequests,
        currentUserInboundRequests: response!.currentUserInboundRequests,
        pendingOrgInvites: response!.pendingInvites,
        currentUserOutboundRequests: response!.currentUserOutboundRequests,
      });
    })
    .fail(notifications.notifyError);
}

export function dismissAllOrgInvites(): void {
  const userId = EntityStore.currentUser().id;
  const currentPendingInvites = (EntityStore.getEntity(userId) as EntityStoreUser).pendingOrgInvites;
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_DISMISS_ALL_ORG_INVITES,
    userId,
  });
  net
    .post({url: '/1/api/users/me/actions/dismiss-organization-invites'})
    .fail(() => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_DISMISS_ALL_ORG_INVITES_FAILED,
        originalPendingInvites: currentPendingInvites,
        userId,
      });
    })
    .fail(notifications.notifyError);
}

export function createInboundRequest(orgId: string): void {
  UserDAO.createInboundRequest(orgId).fail(notifications.notifyError);
}

export function acceptOutboundRequest(orgId: string): void {
  const organization = EntityStore.getEntity(orgId)!;
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_ACCEPT_ORG_REQUEST,
    organizationId: orgId,
    userId: EntityStore.currentUser().id,
  });
  UserDAO.acceptOutboundRequest(orgId)
    .done(() => {
      OnboardingActions.fetchOnboardingTasks();
      notifications.success(`Successfully joined ${organization.name}.`);
    })
    .fail(notifications.notifyError);
}

export function rejectOutboundRequest(orgId: string): void {
  const organization = EntityStore.getEntity(orgId)!;
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_REJECT_ORG_REQUEST,
    organizationId: orgId,
    userId: EntityStore.currentUser().id,
  });
  UserDAO.rejectOutboundRequest(orgId)
    .done(() => {
      notifications.success(`Successfully rejected ${organization.name}'s invite.`);
    })
    .fail(notifications.notifyError);
}

export function getReferrals(): void {
  UserDAO.getReferrals().done((response) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.USER_FETCH_REFERRALS,
      userId: EntityStore.currentUser().id,
      referrals: response!.data,
    });
  });
}

export function getOrMakePublicReferralId(email: string): void {
  UserDAO.getPublicReferralId(email)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_FETCH_REFERRAL_LINK_ID,
        referralLinkId: response!.referralLinkId,
        email,
      });
    })
    .fail(() => {
      UserDAO.createPublicReferralId(email).done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.USER_FETCH_REFERRAL_LINK_ID,
          referralLinkId: response!.referralLinkId,
          email,
        });
      });
    });
}

export function loadMetadata(): void {
  UserDAO.getMetadata().done((metadata) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.USER_FETCH_METADATA,
      userId: EntityStore.currentUser().id,
      metadata,
    });
  });
}
